import { useEffect, useState } from 'react';

const MOBILE_BREAKPOINT = 768;
const TABLET_BREAKPOINT = 1024;

interface BreakpointState {
	isMobile: boolean;
	isTablet: boolean;
	isDesktop: boolean;
}

export const useIsDesktopSize = (): BreakpointState => {
	const getBreakpointState = (): BreakpointState => {
		const width = window.innerWidth;
		return {
			isMobile: width < MOBILE_BREAKPOINT,
			isTablet: width >= MOBILE_BREAKPOINT && width < TABLET_BREAKPOINT,
			isDesktop: width >= TABLET_BREAKPOINT
		};
	};

	const [breakpointState, setBreakpointState] = useState<BreakpointState>(getBreakpointState);

	useEffect(() => {
		const handleResize = () => {
			const breakpointState = getBreakpointState();

			setBreakpointState(prevState => {
				if (
					prevState.isMobile !== breakpointState.isMobile ||
					prevState.isTablet !== breakpointState.isTablet ||
					prevState.isDesktop !== breakpointState.isDesktop
				) {
					return breakpointState;
				}
				return prevState;
			});
		};

		window.addEventListener('resize', handleResize);

		handleResize();

		return () => window.removeEventListener('resize', handleResize);
	}, []);

	return breakpointState;
};
